/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gradeextrainfo2Inputs */

const de__field_gradeextrainfo2 = /** @type {(inputs: _Field_Gradeextrainfo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Angaben`)
};

/**

* @param {_Field_Gradeextrainfo2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gradeextrainfo2 = /** @type {((inputs?: _Field_Gradeextrainfo2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gradeextrainfo2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gradeextrainfo2(inputs)
});
export { _field_gradeextrainfo2 as "_field_gradeExtraInfo" }